// Helper to create boolean select fields for Puck
export const booleanField = {
  type: "select" as const,
  options: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
};

